import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Icon } from "@iconify/react";
import Layout from '../../Components/Layout';
import toast, { Toaster } from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import '../../Assets/CSS/EmployeeOnboard.css'
import { BigerTexts, btnfont, DarkBold, LighterBold, Lightly } from "../../Assets/CSS/Text";
import { Newbtn } from '../../Assets/CSS/Button';
import axios from 'axios';



const OnboardEmployees = () => {
    const navigate = useNavigate();
    const [employee, setEmployees] = useState();
    const [loading, setLoading] = useState(false); // stop skeleton loading

    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    // const [employee, setEmployees] = useState();
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize] = useState(50);
    const [activeDropdown, setActiveDropdown] = useState(null);
    // const [loading, setLoading] = useState(true);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteEmployeeId, setDeleteEmployeeId] = useState(null);
    const openDeleteModal = (empId) => {
        setDeleteEmployeeId(empId);
        setShowDeleteModal(true);
    };
    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setDeleteEmployeeId(null);
    };

    useEffect(() => {
        fetchOnboardEmployee();
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const capitalizeWords = (str) =>
        str.replace(/\b\w/g, (char) => char.toUpperCase());
    const handleSearchChange = (e) =>
        setSearchQuery(e.target.value.toLowerCase());
    const filteredEmployees = (employee || []).filter((emp) => {
        const fullName = `${emp.firstName ?? ""} ${emp.middleName ?? ""} ${emp.lastName ?? ""
            }`.trim();
        return fullName.toLowerCase().includes(searchQuery);
    });
    const toggleMenu = (empId) => {
        setActiveDropdown((prev) => (prev === empId ? null : empId));
    };
    const handleCloseModal = () => {
        setShowModal(false);
    };
    const handleClose = () => {
        setShowEditModal(false);
    };
    const handleOpenModal = () => {
        setShowModal(true);
    };
    // const handleViewEmployee = (emp) => {
    //     navigate(`/emp-onboard/profile/${emp.potentialEmployeeId}`);
    // };
    const handleViewEmployee = (emp) => {
        navigate(`/emp-onboard/profile/${emp.potentialEmployeeId}`, {
            state: { empData: emp }
        });
    };


    const handleEditClick = (emp, showEditModal) => {
        // Remove +91 from mobile number if present
        const cleanedMobile =
            emp.mobileNumber?.startsWith("+91")
                ? emp.mobileNumber.slice(3)
                : emp.mobileNumber ?? "";

        // Store cleaned data for editing
        const updatedEmp = {
            ...emp,
            mobileNumber: cleanedMobile,
        };

        setSelectedEmployee(updatedEmp);
        console.log("Employee data (cleaned for editing):", updatedEmp);
        setShowEditModal(true);
    };

    const handleDeleteEmployee = async (empId) => {
        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/potential-employees/${empId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // ✅ Remove deleted employee from UI
            setEmployees((prev) =>
                prev.filter((emp) => emp.potentialEmployeeId !== empId)
            );

            toast.success("Employee deleted successfully");
        } catch (error) {
            console.error(error);

            toast.error(
                error.response?.data?.message || "Failed to delete employee"
            );
        } finally {
            setLoading(false);
        }
    };
    const confirmDeleteEmployee = async () => {
        if (!deleteEmployeeId) return;

        await handleDeleteEmployee(deleteEmployeeId);

        closeDeleteModal();
    };

    const fetchOnboardEmployee = async () => {
        try {
            setLoading(true)
            const token = localStorage.getItem('token');
            const response = await axios.get(`
                ${process.env.REACT_APP_BACKEND_URL}/api/v1/potential-employees`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "*/*",
                        "Content-Type": "application/json",
                    },
                });
            setEmployees(response.data);
            console.log("hello.....", response.data)
        }
        catch (e) {
            // console.log(e.response.error);
            toast.error(e.error)

        }
        finally {
            setLoading(false)
        }
    }
    return (
        <Layout>
            <Toaster position="top-right" reverseOrder={false} />
            <div className="backgound-main-content">

                <div className="timesheet-header px-2">
                    {isMobile ? (
                        <div className="">
                            <div className="header-mob-title">
                                <h2 >Onboarding List</h2>
                                <button
                                    className="add-emp-mob-button"
                                // onClick={handleOpenModal}
                                >
                                    <div className="add-emp-icon-mob-container">
                                        <Icon
                                            icon="material-symbols:person-add-outline-rounded"
                                            width="18"
                                            height="18"
                                            style={{ color: "#00AFEF" }}
                                        />
                                    </div>
                                </button>
                            </div>

                            <div className="timesheet-controls">
                                <div className="search-bar">
                                    <input
                                        type="text"
                                        className="border-none"
                                        placeholder="Search employee name"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    <Icon
                                        icon="iconamoon:search"
                                        width="20"
                                        height="20"
                                        color="rgba(0, 175, 239, 1)"
                                    />
                                </div>
                            </div>
                            <div className="employee-card-list">
                                {loading
                                    ? // 🔹 Show 6 skeleton cards while loading
                                    Array.from({ length: 6 }).map((_, index) => (
                                        <div className="employee-card" key={index}>
                                            <div className="emp-head">
                                                <p className="emp-id"><Skeleton width={50} height={16} /></p>
                                                <div className="card-actions-menu">
                                                    <Skeleton circle width={20} height={20} />
                                                </div>
                                            </div>
                                            <div className="card-main">
                                                {/* <Skeleton circle width={60} height={60} className="card-avatar" /> */}
                                                <div className="card-info">
                                                    <h4 className="emp-name"><Skeleton width={120} /></h4>
                                                    <p className="emp-email"><Skeleton width={160} /></p>
                                                    <p className="emp-contact"><Skeleton width={100} /></p>
                                                    <p className="emp-department"><Skeleton width={80} /></p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                    :
                                    !filteredEmployees.length ? (
                                        <div style={{ textAlign: "center", padding: "20px", color: "#888" }}>
                                            No Data Found
                                        </div>
                                    ) : (
                                        filteredEmployees.map((emp, index) => {

                                            const fullName = `${emp.firstName ?? ""} ${emp.middleName ?? ""
                                                } ${emp.lastName ?? ""}`.trim();
                                            const avatar = emp.profilePhotoUrl || "";
                                            const empId = emp.empId ?? "-";
                                            const personalEmail = emp.personalEmail ?? "-";
                                            const mobile = emp.mobileNumber ?? "-";
                                            // const department = emp.departmentName ?? "-";
                                            const createdAt = emp.createdAt ?? "-";
                                            const progress = emp.progress ?? "-";

                                            return (
                                                <div className="employee-card" key={index}>
                                                    <div className="emp-head">
                                                        <p className="emp-id">

                                                        </p>
                                                        <div className="card-actions-menu">
                                                            <Icon
                                                                icon="ph:dots-three-vertical-bold"
                                                                className="menu-toggle"
                                                                onClick={() => toggleMenu(emp.empId)}
                                                            />
                                                            {activeDropdown === emp.empId && (
                                                                <div className="menu-dropdown">
                                                                    <span
                                                                        onClick={() => handleViewEmployee(emp)}

                                                                    >
                                                                        View
                                                                    </span>
                                                                    <span onClick={() => handleEditClick(emp)}>
                                                                        Edit
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="card-main">
                                                        {avatar ? (
                                                            <img
                                                                src={avatar}
                                                                alt={fullName}
                                                                className="card-avatar"
                                                            />
                                                        ) : (
                                                            <div className="card-avatar placeholder">
                                                                <Icon icon="proicons:person" className="fs-5" />
                                                            </div>
                                                        )}
                                                        <div className="card-info">
                                                            <h4 className="emp-name">
                                                                {capitalizeWords(fullName)}
                                                            </h4>
                                                            <p className="emp-email">{personalEmail}</p>
                                                            <p className="emp-contact">{mobile}</p>
                                                            <p style={{ marginBottom: 'none' }}>
                                                                {emp.progressType === "box" ? (
                                                                    <div className="progress-box">
                                                                        {emp.progressValue}
                                                                    </div>
                                                                ) : (
                                                                    <div className="progress-wrapper">
                                                                        <span className="progress-percent">{emp.progressValue}%</span>
                                                                        <div className="progress-bar-track">
                                                                            <div
                                                                                className="progress-bar-fill"
                                                                                style={{ width: `${emp.progressValue}%` }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </p>
                                                            <p className="emp-department">
                                                                {createdAt}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }))}
                            </div>
                        </div>
                    ) : (
                        <div className="">
                            <div className="header-title">
                                <h2 style={BigerTexts}>Onboarding List</h2>

                                <button
                                    style={{
                                        ...btnfont,
                                        ...Newbtn
                                    }}
                                    onClick={() => {
                                        navigate("/new-onboard")
                                    }}>
                                    <Icon
                                        icon="material-symbols:add-rounded"
                                        width="18"
                                        height="18"
                                    />
                                    New Onboarding
                                </button>
                            </div>

                            <div className="timesheet-controls">
                                <div className="search-bar" style={{ boxShadow: 'none' }}>
                                    <input
                                        type="text"
                                        className="form-control border-0"
                                        placeholder="Search employee name"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    <Icon
                                        icon="iconamoon:search"
                                        width="20"
                                        height="20"
                                        color="rgba(0, 175, 239, 1)"
                                    />
                                </div>
                            </div>
                            <div className="timesheet-table mb-4">
                                <table className="employee-table timesheet-table ">
                                    <thead>
                                        <tr >
                                            <th style={LighterBold}>Candidate</th>
                                            <th style={LighterBold}>Email</th>
                                            <th style={LighterBold}>Contact Number</th>
                                            <th style={LighterBold}>Created on</th>
                                            <th style={LighterBold}>Progress</th>
                                            <th style={LighterBold}>Actions</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {loading
                                            ? // 🔹 Skeleton rows while loading
                                            Array.from({ length: 5 }).map((_, index) => (
                                                <tr key={index}>
                                                    <td><Skeleton width={70} /></td>
                                                    <td className="employee-info d-flex align-items-center gap-2">
                                                        <Skeleton width={100} />
                                                    </td>
                                                    <td><Skeleton width={120} /></td>
                                                    <td><Skeleton width={100} /></td>
                                                    <td><Skeleton width={80} /></td>
                                                    <td className="d-flex gap-3">
                                                        <Skeleton width={20} height={20} circle />
                                                        <Skeleton width={20} height={20} circle />
                                                    </td>
                                                </tr>
                                            ))
                                            :
                                            // filteredEmployees.map((emp, index) => {
                                            !filteredEmployees.length ? (
                                                <tr>
                                                    <td colSpan="6" style={{ textAlign: "center", padding: "20px", color: "#888" }}>
                                                        No Data Found
                                                    </td>
                                                </tr>
                                            ) : (filteredEmployees.map((emp, index) => {

                                                const fullName = `${emp.firstName ?? ""} ${emp.middleName ?? ""
                                                    } ${emp.lastName ?? ""}`.trim();
                                                // const avatar = emp.profilePhotoUrl || ""; // Show placeholder if null
                                                const personalEmail = emp.personalEmail ?? "-";
                                                const mobile = emp.mobileNumber ?? "-";
                                                const createdAt = emp.createdAt ?? "-";
                                                const progress = emp.progress ?? "-";
                                                const empId = emp.empId ?? " - ";

                                                return (
                                                    <tr key={index} >
                                                        <td>
                                                            <span style={DarkBold}>
                                                                {capitalizeWords(fullName)}
                                                            </span>
                                                        </td>
                                                        <td style={Lightly}>{personalEmail}</td>
                                                        <td style={Lightly}>{mobile}</td>
                                                        <td style={Lightly}>{createdAt}</td>
                                                        <td>
                                                            {emp.progressType === "box" ? (
                                                                <div className="progress-box">
                                                                    {emp.progressValue}
                                                                </div>
                                                            ) : (
                                                                <div className="progress-wrapper">
                                                                    <span className="progress-percent">{emp.progressValue}%</span>
                                                                    <div className="progress-bar-track">
                                                                        <div
                                                                            className="progress-bar-fill"
                                                                            style={{ width: `${emp.progressValue}%` }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </td>



                                                        <td >
                                                            <div className='d-flex gap-3'>


                                                                <Icon
                                                                    icon="hugeicons:view"
                                                                    style={{
                                                                        color: "#00AFEF",
                                                                        fontSize: "18px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={() => handleViewEmployee(emp)}

                                                                // onClick={() => handleViewEmployee(emp.empId)}
                                                                />
                                                                {/* <Icon
                                                                icon="mdi:edit"
                                                                style={{
                                                                    color: "#00AFEF",
                                                                    fontSize: "18px",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => handleEditClick(emp)}
                                                            /> */}
                                                                <Icon
                                                                    icon="material-symbols:delete-outline"
                                                                    style={{
                                                                        color: "#DD0000",
                                                                        fontSize: "18px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={() => openDeleteModal(emp.potentialEmployeeId)}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            }))}
                                    </tbody>
                                </table>
                            </div>
                        </div>



                    )}
                </div>
            </div>
            {/* Delete Confirmation Modal */}
            <div
                className={`modal fade ${showDeleteModal ? "show d-block" : ""}`}
                tabIndex="-1"
                style={{
                    backgroundColor: "rgba(0,0,0,0.5)",
                }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div
                        className="modal-content border-0"
                        style={{
                            borderRadius: "18px",
                            padding: "20px",
                        }}
                    >
                        <div className="modal-body text-center">

                            {/* Delete Icon */}
                            <div
                                className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                                style={{
                                    width: "60px",
                                    height: "60px",
                                    borderRadius: "50%",
                                    background: "#FFEAEA",
                                }}
                            >
                                <Icon
                                    icon="material-symbols:delete-outline-rounded"
                                    width="32"
                                    height="32"
                                    color="#E53935"
                                />
                            </div>

                            {/* Title */}
                            <h2
                                style={{
                                    fontWeight: "700",
                                    marginBottom: "10px",
                                }}
                            >
                                Confirm Delete
                            </h2>

                            {/* Message */}
                            <p
                                style={{
                                    color: "#666",
                                    fontSize: "16px",
                                    marginBottom: "25px",
                                }}
                            >
                                Are you sure you want to delete this employee?
                            </p>

                            {/* Buttons */}
                            <div className="d-flex justify-content-center gap-3">
                                <button
                                    className="btn btn-light px-4"
                                    onClick={() => setShowDeleteModal(false)}
                                    style={{
                                        borderRadius: "10px",
                                        fontWeight: "500",
                                    }}
                                >
                                    Cancel
                                </button>

                                <button
                                    className="btn btn-danger px-4"
                                    style={{
                                        borderRadius: "10px",
                                        fontWeight: "600",
                                    }}
                                    onClick={() => {
                                        handleDeleteEmployee(deleteEmployeeId);
                                        setShowDeleteModal(false);
                                    }}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default OnboardEmployees